<header class="io-bg-dark">
    <nav class="navbar navbar-expand-lg navbar-dark io-bg-dark">
        <div class="container">
            <a class="navbar-brand mr-xl-5" href="#">
                <img src="assets/images/logo-white.png" width="150" height="30" class="d-inline-block align-top mr-2"
                    alt="InsurEco Wallet Admin">
            </a>
            <!--Desktop nav-->
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav">
                    <!-- <a class="nav-item nav-link" routerLink="/dashboard" routerLinkActive="active">
                        <i class='bx-fw bx bx-home-alt'></i>Dashboard
                    </a> -->
                    <a class="nav-item nav-link" routerLink="/wallets" routerLinkActive="active">
                        Wallets
                    </a>
                    <a class="nav-item nav-link" routerLink="/agencies" routerLinkActive="active">
                        Agencies
                    </a>
                    <a class="nav-item nav-link" routerLink="/deposit-requests" routerLinkActive="active">
                        Deposit requests
                    </a>

                    <a class="nav-item nav-link" routerLink="/withdraw-requests" routerLinkActive="active">
                        Withdraw requests
                    </a>
                    <a class="nav-item nav-link" routerLink="/admin-wallet" routerLinkActive="active">
                        Admin wallet
                    </a>
                    <a class="nav-item nav-link" routerLink="/events" routerLinkActive="active">
                        Events
                    </a>
                    <a class="nav-item nav-link" routerLink="/fix-transaction" routerLinkActive="active">
                        Fix transactions
                    </a>
                </div>
            </div>

            <!--Profile-->
            <div dropdown class="dropdown my-profile-btn">
                <button class="btn dropdown-toggle" dropdownToggle type="button">
                    <span class="avtar">
                        <ngx-avatar data-toggle="tooltip" data-placement="top" title="Hello, {{user.firstName}}"
                            src="{{user.avatar}}"
                            name="{{getInitials(user.firstName) + ' ' + getInitials(user.lastName)}}" initialsSize="2"
                            size="35">
                        </ngx-avatar>
                    </span>
                </button>
                <div class="dropdown-menu mt-3 dropdown-menu-right" *dropdownMenu aria-labelledby="dropdownMenu2">
                    <button class="dropdown-item mb-2 disabled">Hello, {{user.firstName}}</button>
                    <button class="dropdown-item mb-2" type="button" routerLink="/user/profile">
                        <i class='bx bx-user bx-fw'></i> My profile
                    </button>
                    <button class="dropdown-item mb-2" type="button" (click)="showChangePasswordModal()">
                        <i class='bx bx-lock-alt bx-fw'></i> Change password
                    </button>
                    <button class="dropdown-item mb-2" type="button" routerLink="/settings/organization">
                        <i class='bx bx-cog bx-fw'></i> Organization settings
                    </button>
                    <div class="dropdown-divider"></div>
                    <button (click)="logout()" class="dropdown-item mb-2" type="button">
                        <i class='bx bx-log-out bx-flip-horizontal bx-fw'></i> Logout</button>
                </div>
            </div>
        </div>
    </nav>
    <!--Mobile bottom nav-->
    <div class="m-bottom-nav bg-white shadow-lg d-lg-none">
        <a href="#">
            <i class='bx bx-home-alt'></i>
            <span>Dashboard</span>
        </a>
        <a href="#" class="active">
            <i class='bx bx-dollar-circle'></i>
            <span>Commissions</span>
        </a>
        <a href="#">
            <i class='bx bx-group'></i>
            <span>Agents</span>
        </a>
        <a href="#">
            <i class='bx bx-wallet-alt'></i>
            <span>My wallet</span>
        </a>
    </div>
</header>
<!--Header end -->